module.exports = __webpack_public_path__ + "static/media/Mobile_Home.97ce68d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewcc/Mobile_Home.png
// module id = 102
// module chunks = 0